export const API_URL = 'incidentDivisions'
export const ROUTE_NAME = 'incidentDivisions'
